import React from 'react';

import type {LicenseType} from 'nutshell-graphql-types';
import type {GetLicenseOverview_licenseOverview_instanceLicenses as LicenseInfo} from 'nutshell-graphql-types';

import {SettingToggle} from './setting-toggle';
import {SwitchText} from './switch-text';

type Props = {
    licenseType: LicenseType;
    licenseInfo: LicenseInfo;
    isOn: boolean;
    purchaseLink?: string | null | undefined;
    infoLink?: string | null | undefined;
    maxSeatsReached: boolean;
    isDisabled: boolean;
    handleSwitchToggle: (licenseType: LicenseType) => void;
};

export function LicenseSwitchVertical(props: Props) {
    const {
        licenseType,
        licenseInfo,
        isOn,
        purchaseLink,
        infoLink,
        maxSeatsReached,
        isDisabled,
        handleSwitchToggle,
    } = props;

    return (
        <SettingToggle
            displayName={licenseInfo.displayName}
            isOn={isOn}
            onToggle={() => handleSwitchToggle(licenseType)}
            isDisabled={isDisabled}
            infoLink={infoLink}
        >
            <SwitchText
                displayName={licenseInfo.displayName}
                // @ts-expect-error
                licenseType={licenseType}
                isPurchased={licenseInfo.isPurchased}
                isUnlimited={licenseInfo.isUnlimited}
                numUsed={licenseInfo.numUsed}
                numBought={licenseInfo.numBought}
                purchaseLink={purchaseLink}
                maxSeatsReached={maxSeatsReached}
            />
        </SettingToggle>
    );
}
